import { render, staticRenderFns } from "./ClientProfileAllVrtTransactions.vue?vue&type=template&id=672850be&scoped=true"
import script from "./ClientProfileAllVrtTransactions.vue?vue&type=script&lang=js"
export * from "./ClientProfileAllVrtTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672850be",
  null
  
)

export default component.exports